import '../api/warnings';
import { push as originalPush, replace as originalReplace } from 'react-router-redux';

export * from './app';
export * from './dashboards';
export * from './livingStrategyDashboard';
export * from './news';
export * from './notificationSettings';
export * from './performanceIndicators';
export * from './sheets';
export * from './swot';
export * from './trendTopics';
export * from 'typed/actions';
export { go, goBack, goForward } from 'react-router-redux';
export { sequence } from '../utils/actionCreatorsFactory';

const queryPreservingRouteAction = (originalAction, location, skipQueryPreservation) => function(dispatch, getState) {
    if (DEBUG && typeof location === 'string' && location.includes('?')) {
        throw new Error('Query strings are not supported. Use Location object.');
    }

    const
        oldLocation = getState().routing.location || getState().routing.locationBeforeTransitions,
        newLocation = {
            pathname: typeof location === 'string' ? location : location.pathname,
            query: { ...location.query },
            state: { internal: true }
        };

    // TODO distinguish Layout's/pages' own/other? query parameters and make Link preserve them while staying in scope of Layout/some page/whatever (route additional property?)
    // currently we store some global/page's parameters in query to make them accessible from outside of the application,
    //      preserve them when page is refreshed accidentally, keep them when opening another copy of a tab etc
    // but handling such parameters was pretty hard - every time we added a parameter we had to check all of existing Links and vice versa (nobody did it actually),
    // otherwise e. g. every click on any Link would exit fullscreen mode
    // it would be much easier if Link itself would preserve some parameters which make sense both on current page and target page,
    // but remove them when user's leaving to another "scope" or parameter has to be removed on purpose (e. g. "exit fullscreen" link)
    // for now a hack - hardcoded list of Layout's parameters and a flag to skip preservation to remove parameters when needed

    if (oldLocation && !skipQueryPreservation) {
        ['askSatisfactionFeedback', 'polls', 'replyPollID', 'replyPollOptionID', 'programs', 'decisions', 'view', 'react_perf', 'general_settings', 'workshopID', 'stepNumber', 'workflowType', 'sprintTriggerID'].forEach((paramName) => {
            if (oldLocation.query[paramName] && !newLocation.query[paramName]) {
                newLocation.query[paramName] = oldLocation.query[paramName];
            }
        });
    }

    return dispatch(originalAction(newLocation, { internal: true }));
};

export const push = queryPreservingRouteAction.bind(null, originalPush);
export const replace = queryPreservingRouteAction.bind(null, originalReplace);

export * from './dynamicIndex';
